import React from 'react';
import { Line } from 'react-chartjs-2';
import styles from "./dasboard.module.css";
import { Chart as ChartJS, LinearScale, CategoryScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

// Register the required Chart.js components
ChartJS.register(LinearScale, CategoryScale, PointElement, LineElement, Title, Tooltip, Legend);

const OrdersChart = ({graphdata}) => {
  // Data for the chart
  const data = {
    labels: graphdata?.labels,
    datasets: [
      {
        label: 'Sales',
        data: graphdata?.data,
        borderColor: 'rgba(143, 58, 210, 1)',
        backgroundColor: 'rgba(143, 58, 210, 0.2)', // Light gradient color
        fill: true,
        tension: 0.3,
        pointRadius: 5,
        pointBackgroundColor: 'rgba(143, 58, 210, 1)',
        borderWidth: 2,
      },
    ],
  };

  // Options for the chart
  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: '#ffffff',
        borderColor: '#dbe5f3',
        borderWidth: 1,
        bodyColor: '#000000',
        titleColor: '#8f3ad2',
        padding: 10,
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Hides the x-axis grid lines
        },
      },
      y: {
        grid: {
          borderColor: '#e0e0e0', // Light border for y-axis grid
        },
        ticks: {
          callback: function (value) {
            return `$${value / 1000}k`; // Format the y-axis ticks
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '100% !important', height: '320px',  borderRadius: '8px', paddingRight:"10px" }}>
      <h3 style={{ fontWeight: 'bold', marginBottom: '10px' }}>Order This Month</h3>
      <h4 style={{ fontWeight: 'bold', color: '#8f3ad2' }}>₹{graphdata?.periodRevenue?.toFixed(2)}</h4>
      <Line data={data} options={options} 
       className={styles.canvasStyle}
       />
    </div>
  );
};

export default OrdersChart;
